var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "images-list",
      on: {
        mouseenter: _vm.openUploadShowClick,
        mouseleave: function ($event) {
          _vm.openUploadShow = false
        },
      },
    },
    [
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.openUploadShow,
              expression: "openUploadShow",
            },
          ],
          staticClass: "openUpload",
          on: { click: _vm.open },
        },
        [_c("i", { staticClass: "el-icon-upload2" }), _vm._v(" 继续上传 ")]
      ),
      _c(
        "el-upload",
        {
          ref: "upload",
          staticClass: "upload-demo",
          attrs: {
            action: _vm.uploadUrl,
            "on-change": _vm.fileListChange,
            "before-upload": _vm.handleBeforeUpload,
            "on-success": _vm.handleSuccess,
            "on-error": _vm.handleUploadError,
            "on-remove": _vm.handleRemove,
            "on-exceed": _vm.handleExceed,
            "on-preview": _vm.handlePictureCardPreview,
            "file-list": _vm.fileList,
            multiple: _vm.fileLimit > 1,
            data: _vm.paramsData,
            limit: _vm.fileLimit,
            "auto-upload": false,
            "list-type": _vm.listType,
          },
        },
        [
          _vm.listType === "picture-card"
            ? _c("i", { staticClass: "el-icon-plus" })
            : _vm._e(),
        ]
      ),
      this.showFlodNames.length > 0
        ? _c(
            "el-dialog",
            {
              staticClass: "productTypeDialog",
              attrs: {
                "custom-class": "chatGPTDialog",
                "append-to-body": true,
                title: "",
                visible: _vm.picShow,
                width: "60%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.picShow = $event
                },
              },
            },
            [
              _c("div", { attrs: { id: "middle" } }, [
                _vm.showFlodNamesFileList.filter(
                  (it) => it.flodName === _vm.pointIndex
                ).length > 0 &&
                (!_vm.showFlodNamesFileList.filter(
                  (it) => it.flodName === _vm.pointIndex
                )[_vm.checkedPic] ||
                  !_vm.showFlodNamesFileList.filter(
                    (it) => it.flodName === _vm.pointIndex
                  )[_vm.checkedPic].id) &&
                _vm.parentId > 0
                  ? _c(
                      "span",
                      {
                        staticClass: "tips noways",
                        on: {
                          click: function ($event) {
                            _vm.singleUploadFlodName(
                              _vm.showFlodNamesFileList.filter(
                                (it) => it.flodName === _vm.pointIndex
                              )[_vm.checkedPic]
                            )
                          },
                        },
                      },
                      [
                        _c("i", { class: _vm.icon }),
                        _vm._v(_vm._s(_vm.iconText)),
                      ]
                    )
                  : _vm._e(),
                _c("i", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isExistence,
                      expression: "isExistence",
                    },
                  ],
                  staticClass: "el-icon-arrow-left pointLeft",
                  on: { click: _vm.reduceFlodName },
                }),
                _c("i", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isExistence,
                      expression: "isExistence",
                    },
                  ],
                  staticClass: "el-icon-arrow-right pointRight",
                  on: { click: _vm.addFlodName },
                }),
                _c("img", { attrs: { src: _vm.bigPic } }),
                _vm.isExistence
                  ? _c("span", { staticClass: "Page" }, [
                      _vm._v(
                        _vm._s(_vm.checkedPic + 1) +
                          "/" +
                          _vm._s(
                            _vm.showFlodNamesFileList.filter(
                              (it) => it.flodName === _vm.pointIndex
                            ).length
                          )
                      ),
                    ])
                  : _vm._e(),
              ]),
              _c(
                "div",
                { staticClass: "btnBox" },
                _vm._l(_vm.showFlodNames, function (n, index) {
                  return _c(
                    "el-button",
                    {
                      key: index,
                      class: _vm.pointIndex === n ? "active" : "",
                      attrs: { round: "" },
                      on: {
                        click: function ($event) {
                          return _vm.pointActive(n)
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(n) +
                          "（" +
                          _vm._s(
                            _vm.showFlodNamesFileList.filter(
                              (it) => it.flodName === n
                            ).length
                          ) +
                          "） "
                      ),
                    ]
                  )
                }),
                1
              ),
              _vm.isExistence
                ? _c(
                    "div",
                    {
                      staticClass: "hiddenScrollbar",
                      attrs: { id: "photoWall" },
                    },
                    _vm._l(
                      _vm.showFlodNamesFileList.filter(
                        (it) => it.flodName === _vm.pointIndex
                      ) || [],
                      function (pic, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "picKuai",
                            class: _vm.checkedPic === index ? "checkedPic" : "",
                          },
                          [
                            _c("img", {
                              attrs: { src: pic.url },
                              on: {
                                click: function ($event) {
                                  return _vm.checkedPicPointFlodName(pic, index)
                                },
                              },
                            }),
                            _c(
                              "span",
                              {
                                staticClass: "tips delete",
                                on: {
                                  click: function ($event) {
                                    return _vm.deletePicFlodName(index)
                                  },
                                },
                              },
                              [_c("i", { staticClass: "el-icon-delete" })]
                            ),
                          ]
                        )
                      }
                    ),
                    0
                  )
                : _vm._e(),
            ]
          )
        : _c(
            "el-dialog",
            {
              staticClass: "productTypeDialog",
              attrs: {
                "custom-class": "chatGPTDialog",
                "append-to-body": true,
                title: "",
                visible: _vm.picShow,
                width: "60%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.picShow = $event
                },
              },
            },
            [
              _c("div", { attrs: { id: "middle" } }, [
                _vm.fileList.length > 0 &&
                (!_vm.fileList[_vm.checkedPic] ||
                  !_vm.fileList[_vm.checkedPic].id) &&
                _vm.parentId > 0
                  ? _c(
                      "span",
                      {
                        staticClass: "tips noways",
                        on: {
                          click: function ($event) {
                            return _vm.singleUpload(
                              _vm.fileList[_vm.checkedPic]
                            )
                          },
                        },
                      },
                      [
                        _c("i", { class: _vm.icon }),
                        _vm._v(_vm._s(_vm.iconText)),
                      ]
                    )
                  : _vm._e(),
                _c("i", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isExistence,
                      expression: "isExistence",
                    },
                  ],
                  staticClass: "el-icon-arrow-left pointLeft",
                  on: { click: _vm.reduce },
                }),
                _c("i", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isExistence,
                      expression: "isExistence",
                    },
                  ],
                  staticClass: "el-icon-arrow-right pointRight",
                  on: { click: _vm.add },
                }),
                _c("img", { attrs: { src: _vm.bigPic } }),
                _vm.isExistence
                  ? _c("span", { staticClass: "Page" }, [
                      _vm._v(
                        _vm._s(_vm.checkedPic + 1) +
                          "/" +
                          _vm._s(_vm.fileList.length)
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm.isExistence
                ? _c(
                    "div",
                    {
                      staticClass: "hiddenScrollbar",
                      attrs: { id: "photoWall" },
                    },
                    _vm._l(_vm.fileList || [], function (pic, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "picKuai",
                          class: _vm.checkedPic === index ? "checkedPic" : "",
                        },
                        [
                          _c("img", {
                            attrs: { src: pic.url },
                            on: {
                              click: function ($event) {
                                return _vm.checkedPicPoint(pic, index)
                              },
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticClass: "tips delete",
                              on: {
                                click: function ($event) {
                                  return _vm.deletePic(index)
                                },
                              },
                            },
                            [_c("i", { staticClass: "el-icon-delete" })]
                          ),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }